import Vue from 'vue'
import faqItem from '../views/faq.vue'

export default {
    init() {
        if ($('[data-faq-module]').length) {
            $('[data-faq-module]').each(function () {
                const faq = new Vue({
                    el: this,
                    components: {
                        faq: faqItem,
                    },
                    data: {
                        activePanel: null,
                    },
                })
            })
        }
    },
}
